import { formatHistoricoDocumentacaoDataHora } from "../../../utils/date";
import type { PagamentoEventoItem } from "../../../services/pagamentoAvaliacaoService";
import type { PaymentHistoryEntry } from "./paymentListTypes";
import { normalizeText } from "../../../utils";

function resolveAcao(nome: unknown): string {
  const acao = String(nome || "").trim();
  if (!acao) return "-";
  if (normalizeText(acao).includes("pag gerado")) {
    return "Em aprovação no Fusion";
  }
  return acao;
}

export function mapPagamentoEventosToHistory(
  eventos: PagamentoEventoItem[] | null | undefined,
): PaymentHistoryEntry[] {
  if (!Array.isArray(eventos)) return [];

  return eventos.map((entry, index) => {
    const arquivoRaw = entry?.arquivoId;
    const arquivoNum = Number(arquivoRaw);
    const arquivoId =
      arquivoRaw != null && Number.isFinite(arquivoNum) && arquivoNum > 0
        ? arquivoNum
        : null;

    return {
      id: Number(entry?.id) || index + 1,
      acao: resolveAcao(entry?.nome),
      data: formatHistoricoDocumentacaoDataHora(entry?.criadoEm),
      arquivoId,
    };
  });
}
